import axios from "axios";
import { encryptData, decryptData } from "./encryption";
// import { getToken } from '../utils/storage';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Base URL from environment variables
  timeout: 60000, // Request timeout
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add Authorization header
    // const token = getToken();
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`;
    // }
    config.headers["Shubham"] = "Nikhil";

    // Encrypt request data
    // if (config.data) {
    //   config.data = encryptData(config.data);
    // }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Decrypt response data
    // if (response.data) {
    //   response.data = decryptData(response.data);
    // }
    return response;
  },
  (error) => {
    // Handle errors globally
    if (error.response?.status === 401) {
      // Handle unauthorized access (e.g., redirect to login)
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
